import { postCoreDataSecurityAccessAnomalyAlertsExportSlice } from './post';

export const {
	requestPostCoreDataSecurityAccessAnomalyAlertsExport,
	resetPostCoreDataSecurityAccessAnomalyAlertsExport
} = postCoreDataSecurityAccessAnomalyAlertsExportSlice.asyncActionCreators;
